/** @type {import('../schema').ProcessDefinition} */
const revisiones = {
  id: "revisiones",
  name: "Revisiones / inspecciones técnicas",
  category: "operaciones",
  outcome:
    "Cumplir las inspecciones obligatorias (gas, ascensor, eléctrica) y llevar su historial.",
  trigger:
    "El Administrador abre Mantenimientos; el sistema marca próximos vencimientos.",
  actors: ["Administrador", "Sistema", "Proveedor"],
  status: "COMPLETO",
  description:
    "Agenda de inspecciones técnicas obligatorias por edificio: inicialización del schedule con los flags del edificio, items con frecuencia y próximo vencimiento, registro de la inspección realizada por la empresa inspectora e historial por tipo.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
    { id: "prov", actor: "Proveedor" },
  ],
  steps: [
    { id: "s1", laneId: "admin", type: "start", label: "Abre Mantenimientos", description: "El admin entra al módulo de revisiones/inspecciones.", evidence: "src/screens/admin/Mantenimiento.jsx:146" },
    { id: "s2", laneId: "admin", type: "decision", label: "¿Existe el schedule?" },
    { id: "s3", laneId: "admin", type: "task", label: "Inicializa el schedule", description: "Lo inicializa con los flags del edificio (ascensor, gas). /api/maintenance-schedule/init." },
    { id: "s4", laneId: "sys", type: "task", label: "Arma la agenda", description: "Items con tipo, frecuencia, último realizado y próximo vencimiento; destaca los próximos a vencer." },
    { id: "s5", laneId: "prov", type: "handoff", label: "Empresa inspectora realiza la inspección", description: "La empresa externa ejecuta la inspección (OK o con observaciones)." },
    { id: "s6", laneId: "admin", type: "task", label: "Registra realizado (mark-done)", description: "Marca la inspección como realizada con los datos de la empresa.", evidence: "src/screens/admin/RevisionesAdmin.jsx" },
    { id: "s7", laneId: "admin", type: "end", label: "Historial actualizado", description: "Consulta las inspecciones por tipo; los vencimientos sin realizar se destacan." },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3", label: "no existe" },
    { from: "s2", to: "s4", label: "existe" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7" },
  ],
};

export default revisiones;
